import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.floating-feature-cards' ).length ) {
        if ( window.hasMotion ) {
          $( '.floating-feature-cards' ).each( function( index, section ) {
            const cards = $( section ).find( '.js-scroll-slide' );
            const mm = gsap.matchMedia();

            mm.add( '(min-width: 1024px)', function() {
              section.style.setProperty( '--card-count', cards.length );

              $( cards ).each( function( index, card ) {
                gsap.to( card, {
                  yPercent: 20,
                  scrollTrigger: {
                    trigger: card,
                    start: 'top-=50 center',
                    scrub: 0.5,
                  },
                } );

                gsap.fromTo(
                    card,
                    {opacity: 0, filter: 'blur(20px)'},
                    {
                      opacity: 1,
                      filter: 'blur(0px)',
                      scrollTrigger: {
                        trigger: card,
                        start: 'top bottom',
                        end: 'top center',
                        scrub: 0.5,
                      },
                    },
                );
              } );

              return function() {
                section.style.removeProperty( '--card-count' );
              };
            } );

            mm.add( '(max-width: 1023px)', function() {
              $( cards ).each( function( index, card ) {
                gsap.fromTo(
                    card,
                    {opacity: 0, filter: 'blur(20px)'},
                    {
                      opacity: 1,
                      filter: 'blur(0px)',
                      scrollTrigger: {
                        trigger: card,
                        start: 'top bottom',
                        end: 'top center',
                        scrub: 0.5,
                      },
                    },
                );
              } );
            } );
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'floating-feature-cards', COMPONENT );
} )( app );
